import {flow, getEnv, types} from "mobx-state-tree";
import ExtendedDataSetStore from "../../stores/domain/ExtendedDataSetStore";

export const ExtendedDataSetListModel = types.model("ExtendedDataSetListModel", {
  store: types.maybe(types.late(() => types.reference(ExtendedDataSetStore))),
  isLoading: types.optional(types.boolean, false),
  page: types.optional(types.integer, 1),
  perPage: types.optional(types.integer, 10),
  totalRows: types.optional(types.integer, 0),
  sortOrder: types.optional(types.string, "desc"),
  sortField:  types.optional(types.string, "updatedAt"),
}).volatile(self => ({
  searchParams: {},
  filters: {}
})).actions((self) => ({
  getItems() {
    return self.store.extendedDataSetList || [];
  },
  setSortOrder(sortDirection){
    self.sortOrder = sortDirection;
  },
  setSortField(sortField){
    self.sortField = sortField;
  },
  fetchAll: flow(function* fetchAll(sortParams = {}) {
    self.isLoading = true;
    try {
      const queryParams = {
        page: self.page,
        perPage: self.perPage,
        ...sortParams,
        ...self.searchParams
      };
      console.log("ExtendedDataSetListModel.fetchAll: ", queryParams);

      const response = yield getEnv(self).extendedDataManager.fetchAllExtendedDataSet(queryParams, self);

      if (response != null) {
        console.log("ExtendedDataSetListModel.fetchAll: ", response.results);
        self.store.setList(response?.results);
        self.totalRows = response._meta?.itemCount;
      }
      self.isLoading = false;
    } catch (error) {
      console.error("Error in ExtendedDataSetListModel.fetchAll: ", error?.message);
      console.error(error);
    }
  }),
  fetchAllFilters: flow(function* fetchAllFilters(sortParams = {}) {
    self.isLoading = true
    try {
      const queryParams = {
        ...self.searchParams
      };
      console.log("ExtendedDataSetListModel.fetchAllFilters: queryParams", queryParams);

      let response = yield getEnv(self).extendedDataManager.fetchAllExtendedDataSetFilters(queryParams, self);
      console.log("ExtendedDataSetListModel.fetchAllFilters: response", response);
      if (response != null) {
        self.filters = response;
      }
      self.isLoading = false;
    }
    catch (error) {
      console.error("Error in ExtendedDataSetListModel.fetchAllFilters: ", error?.message);
      console.error(error);
    }
  }),
  updatePage(page) {
    self.page = page;
  },
  updatePerPage(perPage) {
    self.perPage = perPage;
  },
  addSearchParams(param){
    self.searchParams = {...self.searchParams, ...param};
  },
  removeSearchParams(names, regex = ''){
    if (names) {
      names.map((name) => delete self.searchParams[name]);
    }
    if (regex) {
      const keysToDelete = Object.keys(self.searchParams).filter(key => regex.test(key));
      keysToDelete.forEach(key => delete self.searchParams[key]);
    }
  },
  afterCreate() {
    console.log("ExtendedDataSetListModel.afterCreate");
    self.searchParams = {};
  },
})).views((self) => ({
  getSearchParams() {
    return self.searchParams;
  }
}));
